import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { StoreAndLanguage } from '@core/domain/state/core.state';
import { getCatalogId, getCmsConfigValue, getStoreAndLanguage, getXConfigurationValue } from '@core/infrastructure/state/core.selectors';
import { selectUserIsLogged } from '@shared/user/store';

/**
 * Facade para peticiones a la store externa
 */
@Injectable()
export class WishlistSharedQueriesFacade {
    constructor(
        private readonly store: Store,
    ) { }

    public selectUserIsLogged$(): Observable<boolean> {
        return this.store.select(selectUserIsLogged);
    }

    public getStoreAndLanguage$(): Observable<StoreAndLanguage> {
        return this.store.select(getStoreAndLanguage);
    }

    public getCatalogId$(): Observable<string> {
        return this.store.select(getCatalogId);
    }

    public getCmsConfigValue$(config: string): Observable<any> {
        return this.store.select(getCmsConfigValue(config));
    }

    public getXConfigValue$(config: string): Observable<any> {
        return this.store.select(getXConfigurationValue(config));
    }
}
